import { Observable } from 'rxjs';
import { HttpClientInterface } from '@itk/http-client-interface';
import {
  ConditionRequest,
  ConditionDataResponse,
  DrugRequest,
  DrugDataResponse,
  ComboDataResponse,
  HospitalizationRequest,
  HospitalizationDataResponse,
} from '../models/autofill.model';
import { UnderwritingItem } from '../django-api';

export class AutofillEndpoint {
  constructor(private readonly http: HttpClientInterface) {}

  condition(req: ConditionRequest): Observable<ConditionDataResponse> {
    return this.http.get<ConditionDataResponse>({
      url: '/autofill/condition/',
      queryParams: req as unknown as Record<string, string>,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  drug(req: DrugRequest): Observable<DrugDataResponse> {
    return this.http.get<DrugDataResponse>({
      url: '/autofill/drug/',
      queryParams: req as unknown as Record<string, string>,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  hospitalization(
    req: HospitalizationRequest,
  ): Observable<HospitalizationDataResponse> {
    return this.http.get<HospitalizationDataResponse>({
      url: '/autofill/hospitalization/',
      queryParams: req as unknown as Record<string, string>,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  combo(req: UnderwritingItem[]): Observable<ComboDataResponse> {
    return this.http.post<ComboDataResponse, UnderwritingItem[]>({
      url: '/autofill/combo/',
      body: req,
      headers: { 'Content-Type': 'application/json' },
    });
  }
}
